import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import styles from 'assets/jss/material-kit-react/views/landingPage.js'
import ModalDialog from '../../components/ModalDialog'
import TransactionCost from './TransactionCost'
import { Button } from '@material-ui/core'
import { getAccountBalanceEth } from 'eth/ethUtils'
import { getTokenPrice } from 'eth/ethUtils'
import { getGasEstimateToPurchase } from 'eth/ethUtils'
import { purchase } from 'eth/ethUtils'
import { useHistory,useParams } from 'react-router'
import { getBrandName } from 'util/brandUtils'
import { getDisplayType } from 'redux/actions/displayActions'
import { isSafeToMint } from 'eth/ethUtils'
import { tokenDisclaimer } from 'eth/tokenUtils'
import { setTransactionInProgress } from 'redux/actions/displayActions'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'
import { getActualGasCost } from 'eth/ethUtils'
import { getDisplayError } from 'eth/tokenUtils'

import { decodeHarmonizeError } from 'eth/ethUtils'
import TimerProgress from '../mint/TimerProgress'
import { getEthOrLocalPrice } from 'eth/ethUtils'
import ErrorLine from 'components/ErrorLine'
import { getCurrentAsset } from 'redux/actions/assetActions'
import { getOwner } from 'eth/ethUtils'
const useStyles = makeStyles(styles)
function Alert(props) {
    return <MuiAlert elevation={6} variant='filled' {...props} />
}
export default function Purchase({ eth }) {
    const { tokenId } = useParams()
    const currentAsset = getCurrentAsset()
    const history = useHistory()

    const [tokenPrice, setTokenPrice] = useState(0)
    const [confirmAction, setConfirmAction] = useState(false)
    const [gasEstimate, setGasEstimate] = useState()
    const [actualGasCost, setActualGasCost] = useState()
    const [ethBalance, setEthBalance] = useState()
    const [tokenMessage, setTokenMessage] = useState()
    const [showSnack, setShowSnack] = useState(false)
    const [owner, setOwner] = useState()
    const [error, setError] = useState('')

    const { ethAccount } = useSelector((state) => state.account)

    const { currency, showEthInCurrency } = useSelector((state) => state.settings)
    const { transactionInProgress } = useSelector((state) => state.display)

    const classes = useStyles()
    const dispatch = useDispatch()

    const displayHarmonizeError = (error) => {
        getDisplayError(error, setError)
    }

    const setNoConfirm = () => {
        setConfirmAction(false)
    }

    const snackClose = () => {
        setShowSnack(false)
        history.replace('/Vault')
    }
    const snackPurchaseCompleted = () => {
        if (showSnack) {
            return (
                <Snackbar open={showSnack} autoHideDuration={6000} onClose={snackClose}>
                    <Alert onClose={snackClose} severity='success'>
                        <span>
                            <b>Congratulations!</b> Your purchase has completed. You are now
                            the proud owner of a {getBrandName(getDisplayType())} NFT.
                        </span>
                    </Alert>
                </Snackbar>
            )
        }
    }
    const purchaseCompleted = (receipt) => {
        console.log('purchaseCompleted', receipt)
        setTokenMessage('Your token purchase has completed.')
        dispatch(setTransactionInProgress(false))
        const gasCost = getActualGasCost(receipt)
        setActualGasCost(gasCost)
        setShowSnack(true)
    }
    const purchaseStarted = (txHash) => {
        console.log('purchaseStarted', txHash)
        setTokenMessage('Transaction started...')
    }
    const purchaseFailed = (error) => {
        dispatch(setTransactionInProgress(false))
        displayHarmonizeError(error)
    }
    const purchaseToken = async () => {
        setTokenMessage('Purchase in progress, please wait...')
        dispatch(setTransactionInProgress(true))
        try {
            await purchase(
                owner,
                tokenId,
                tokenPrice,
                purchaseStarted,
                purchaseCompleted,
                purchaseFailed
            )
        } catch (error) {
            console.error('purchase FAILED', error)
            displayHarmonizeError(error)
        }
    }

    const displayPurchase = () => {
        if (!showSnack) {
            const safe = ethAccount
                ? isSafeToMint(gasEstimate, ethBalance, tokenPrice)
                : false
            const disabled = transactionInProgress || !safe || error.length !== 0
            console.log(`displayPurchase ${tokenPrice} safe ${safe}`)
            return (
                <>
                    {!error && safe ?(
                        <TransactionCost
                            gasEstimate={gasEstimate}
                            action={'purchase'}
                            ethInCurrency={eth}
                            ethBalance={ethBalance}
                            actualGasCost={actualGasCost}
                            price={tokenPrice}
                        />
                    ):<h4 style={{textAlign:'center'}}>Not safe to mint</h4>}

                    <Button
                        disabled={disabled}
                        variant='contained'
                        color='primary'
                        className={classes.submit}
                        style={{
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            display: 'flex',
                        }}
                        onClick={() => setConfirmAction(true)}
                    >
                        Purchase
                    </Button>
                </>
            )
        }
    }

    const displayPrice = () => {
        if (!transactionInProgress) {
            if (tokenPrice > 0) {
                return (
                    <div>
                        <p style={{ fontWeight: 'bold', textAlign: 'center' }}>
                            Price:&nbsp;
                            {getEthOrLocalPrice(tokenPrice, eth, currency, showEthInCurrency)}
                        </p>

                        {displayPurchase()}
                    </div>
                )
            } else {
                return (
                    <>
                        <p style={{ fontStyle: 'italic', textAlign: 'center' }}>
                            This NFT is not for sale
                        </p>
                    </>
                )
            }
        }
    }

    const displayTransactionInProgress = () => {
        if (transactionInProgress) {
            return (
                <div style={{ height: '20vh', width: '100%', textAlign: 'center' }}>
                    {tokenMessage && (
                        <h4 style={{ textAlign: 'center' }}>{tokenMessage}</h4>
                    )}
                    <TimerProgress label='Transaction in progress...' height={5} />
                </div>
            )
        }
    }

    const getGasEstimate = async () => {
        if (tokenPrice > 0) {
            try {
                setError('')
                const estimate = await getGasEstimateToPurchase(tokenId, tokenPrice)
                setGasEstimate(estimate)
            } catch (error) {
                displayHarmonizeError(decodeHarmonizeError(error))
            }
        }
    }
    const getEthBalance = async () => {
        try {
            const balance = await getAccountBalanceEth()
            setEthBalance(balance)
        } catch (error) {
            console.error('getEthBalance failed', error)
            setError(JSON.stringify(error))
        }
    }
    const getCurrentTokenPrice = async () => {
        console.log(`getCurrentTokenPrice ${tokenId}`)
        try {
            const owner = await getOwner(tokenId)
            if (owner) {
                setOwner(owner)
                const currentPrice = await getTokenPrice(tokenId)
                console.log(`getCurrentTokenPrice ${currentPrice}`)
                if (currentPrice) {
                    setTokenPrice(currentPrice)
                    await getGasEstimate(owner)
                }
            }
        } catch (error) {
            console.error('Error getting token price', error)
            displayHarmonizeError(error)
        }
    }

    const getModal = () => {
        return (
            <ModalDialog
                title='Confirm Purchase'
                message={tokenDisclaimer('purchase')}
                close={() => {
                    setNoConfirm()
                }}
                open={confirmAction}
                noLabel='No'
                no={() => setNoConfirm()}
                yesLabel='Yes'
                yes={() => {
                    setNoConfirm()
                    purchaseToken()
                }}
            />
        )
    }

    useEffect(() => {
        if (ethAccount) {
            if (!ethBalance) {
                getEthBalance()
            }
            if (!actualGasCost) {
                getCurrentTokenPrice()
            }
        }
    }, [ethBalance, tokenPrice, actualGasCost])
    if (currentAsset) {
        return (
            <>
                <ErrorLine error={error} />
                {!transactionInProgress ? displayPrice() : null}

                {displayTransactionInProgress()}
                {snackPurchaseCompleted()}
                {getModal()}
            </>
        )
    }
    return null
}